<template>
  <div class="edit-guestbook-pages">
    <!-- temporary style -->
    <h2 class="h4 add--text-align-center" style="margin-bottom: 20px">
      You are now editing:
      <span class="h2">{{ selectedPageNameUnchanged }}</span>
    </h2>

    <div class="input-textfield">
      <label for="pageTitle">Title</label>
      <input
        type="text"
        id="pageTitle"
        v-model="selectedPageName"
        maxlength="50"
      />
    </div>

    <language-adaptive-select
      v-if="!$isSingleLanguage"
      @change="toggleLanguage"
      :languageTypes="languageTypes"
      :localLanguageTypesIndex="localLanguageTypesIndex"
    />

    <!-- LANGUAGE SELECT END -->
      <div class="input-group" v-if="loaded">
        <div class="input-textarea input-tiny">
          <label>Content</label>
          <HtmlEditor
            v-for="languageIndex in languageIndeces" 
            :key="languageIndex"
            v-show="languageIndex == localLanguageTypesIndex"
            v-model="contents[languageIndex]" 
            :unsetHeight="true"
          />
        </div>
      </div>

    <div class="button-container">
      <button class="button-neutral" @click="cancelEdit">Cancel</button>
      <button class="button-positive" @click="updatePage">Save</button>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase";
import bus from "@/bus";
import HtmlEditor from "@/components/GlobalComponents/HtmlEditor";
import newLanguageTypesFormatMixin from "@/mixins/newLanguageTypesFormatMixin";
import LanguageAdaptiveSelect from '@/components/Ui/LanguageAdaptiveSelect';

export default {
  components: {
    HtmlEditor,
    LanguageAdaptiveSelect
  },
  mixins: [newLanguageTypesFormatMixin],
  props: {
    pageSelected: String,
    pageName: String,
    pagePath: String,
  },
  data() {
    return {
      contents: [],
      loaded: false,
      selectedPageName: "New Page",
      selectedPageNameUnchanged: "New Page",
      languageTypes: [],
      languageIndeces: [],
      localLanguageTypesIndex: 0,
    };
  },
  firebase() {
    return {
      hotelPageContent: {
        source: db.ref(`/pages/${this.$customerId}/${this.$hotelId}/${this.pageSelected}`),
        asObject: true,
        readyCallback: (data) => {
          this.contents = data.val();
          this.loaded = true;
        },
      }
    };
  },
  async created() {
    this.localLanguageTypesIndex = await this._getLanguageIndex();
    this.languageTypes = await this._getCorrectEventLanguages();
    this.languageIndeces = new Array(this.languageTypes.length).fill().map((d,i)=>i);

    this.selectedPageName = this.pageName;
    this.selectedPageNameUnchanged = this.pageName;
  },
  methods: {
    updatePage() {
      let contentPromise = db
        .ref(`/pages/${this.$customerId}/${this.$hotelId}/${this.pageSelected}/`).set(this.contents);
      let pageNamePromise = db
        .ref(`/pages/${this.$customerId}/${this.$hotelId}/overview/${this.pageSelected}/`)
        .child("name")
        .set(this.selectedPageName);

      Promise.all([
        contentPromise,
        pageNamePromise,
      ]).then(() => {
        this.$toastEvents.push({
          type: "positive",
          title: "Pages",
          content: "Page has been updated",
          id: +new Date(),
        });
        bus.$emit("closeSelectedPage");
      });
    },
    cancelEdit() {
      bus.$emit("closeSelectedPage");
    },
    toggleLanguage(indexClicked) {
      this.localLanguageTypesIndex = indexClicked;
    },
  },
};
</script>

<style scoped>
/* >>> Change the looks of Tiny MCE to fit in a little better <<< */
.input-group >>> .tox {
  border: 2px solid var(--grey);
  border-radius: var(--border-radius);
}

.input-tiny label {
  z-index: 2;
}

.h2 {
  color: var(--primary);
}

/* .languagebarWrapper {
  margin-top: 10px;
  border: 2px solid var(--grey);
  border-radius: var(--border-radius);
}
.pageOuterWrap, .pageLinkWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid var(--grey);
  border-radius: var(--border-radius);
  background-color: #FFFFFF;
  padding: 7px;
  margin-bottom: 20px;
  height: 70px;
}
.pageTitleWrap {
  display: flex;
  margin-left: 10px;
}
.pageTitleWrap > input {
  padding: 10px 15px;
  width: 250px;
  color: #66615B;
  border: 2px solid var(--grey);
  border-radius: var(--border-radius);
	outline: 0;
  margin-left: 10px;
}
.pageTitleWrap > a {
  padding: 10px 15px;
  color: #66615B;
}
.languagebarWrapper {
  padding: 9px;
}
.languageName {
  margin-left: 10px;
  font-size: 20px;
}
.pageTitleWrap > img {
  width: 50px;
  height: 50px;
}
.pageTitleWrap > p {
  margin-left: 20px;
}
.btnWrap {
  display: flex;
}
.btnWrap > div {
  margin-right: 10px;
}
.editorWrap {
  height: 700px;
  margin-top: 25px;
  padding: 10px;
}
select#langType {
  color: #707070;
  background-color: rgb(255, 255, 255);;
  font-weight: bold;
  border: 1px solid #707070;
  border-radius: 4px;
  padding-left: 50px;
  width: 250px;
  height: 50px;
  margin-right: 20px;
}
.selectWrapper {
  position: relative;
}
.selectWrapper > img {
  position: absolute;
  width: 40px;
  top: 4px;
  left: 5px;
}
@media ( max-width: 890px) {
.pageOuterWrap {
  display: flex;
  flex-direction: column;
  height: auto;
}
.pageTitleWrap > img {
  display: none;
}
.btnWrap {
  margin-top: 15px;
  margin-bottom: 10px;
  margin-left: 20px;
  display: flex;
 }
.btnWrap > div {
  margin: 0;
 }
} */
</style>
